import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import './index.css';
import App from './App';
import { I18nProvider } from './i18n';

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

function Root() {
  const tree = (
    <BrowserRouter>
      <I18nProvider>
        <App />
      </I18nProvider>
    </BrowserRouter>
  );
  if (!siteKey) return tree;
  return (
    <GoogleReCaptchaProvider reCaptchaKey={siteKey} scriptProps={{ async: true, defer: true }}>
      {tree}
    </GoogleReCaptchaProvider>
  );
}

const root = createRoot(document.getElementById('root'));
root.render(<React.StrictMode><Root /></React.StrictMode>);
